import styled from 'styled-components';

// Assets

// Interface

export const Container = styled.section``;

export const Imagem = styled.img``;
